var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66699 2.66663H6.33366C6.88594 2.66663 7.33366 3.11434 7.33366 3.66663V4.33329C7.33366 4.88558 6.88594 5.33329 6.33366 5.33329H3.66699C3.11471 5.33329 2.66699 4.88558 2.66699 4.33329V3.66663C2.66699 3.11434 3.11471 2.66663 3.66699 2.66663ZM9.66699 10.6666H12.3337C12.8859 10.6666 13.3337 11.1143 13.3337 11.6666V12.3333C13.3337 12.8856 12.8859 13.3333 12.3337 13.3333H9.66699C9.11471 13.3333 8.66699 12.8856 8.66699 12.3333V11.6666C8.66699 11.1143 9.11471 10.6666 9.66699 10.6666Z",
    fill: "#323130"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66699 6.66663H6.33366C6.88594 6.66663 7.33366 7.11434 7.33366 7.66663V12.3333C7.33366 12.8856 6.88594 13.3333 6.33366 13.3333H3.66699C3.11471 13.3333 2.66699 12.8856 2.66699 12.3333V7.66663C2.66699 7.11434 3.11471 6.66663 3.66699 6.66663ZM9.66699 2.66663H12.3337C12.8859 2.66663 13.3337 3.11434 13.3337 3.66663V8.33329C13.3337 8.88558 12.8859 9.33329 12.3337 9.33329H9.66699C9.11471 9.33329 8.66699 8.88558 8.66699 8.33329V3.66663C8.66699 3.11434 9.11471 2.66663 9.66699 2.66663Z",
    fill: "#323130"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.11b0b7ba.svg";
export { ForwardRef as ReactComponent };